export default "__VITE_ASSET__BK357lNc__"